import request from '@/utils/request'

function list (params) {
  const qsParams = new URLSearchParams();
  for (var key in params) {
    qsParams.append(key,params[key])
  }
 
  return request({
    url: `/audio?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function download (params) {
  const qsParams = new URLSearchParams();
  for (var key in params) {
    qsParams.append(key,params[key])
  }
 
  return request({
    url: `/audio/export?${qsParams.toString()}`,
    method: 'get',
    responseType: 'blob',
    data: params
  })
}
function add (params) {
  return request({
    url: `/audio`,
    method: 'post',
    data: params
  })
}
function batch (params) {
  return request({
    url: `/audio/batch`,
    method: 'post',
    data: params
  })
}
function batchDelete (params) {
  return request({
    url: `/audio/batchDelete`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/audio/${params.id}`,
    method: 'put',
    data: params
  })
}
function remove (organization_id) {
  return request({
    url: `/audio/${organization_id}`,
    method: 'delete'
  })
}
export default {
    list,
    add,
    update,
    remove,
    batch,
    batchDelete,
    download
}
